import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EFrequency = {
	immediately: 'IMMEDIATELY',
	inRepetitions: 'IN_REPETITIONS',
} as const;

export const ERenotify = {
	doNotNotify: 'DO_NOT_NOTIFY',
	whenOccursAgain: 'WHEN_OCCURS_AGAIN',
	afterSincePrevious: 'AFTER_SINCE_PREVIOUS',
} as const;

export const EAlarmStatus = {
	active: 'ACTIVE',
	cleared: 'CLEARED',
} as const;

export const EAlarmStatusTitle = {
	inactive: 'Cleared',
	active: 'Active',
} as const;

export type TFrequency = TValueOfStringRecord<typeof EFrequency>
export type TRenotify = TValueOfStringRecord<typeof ERenotify>
export type TAlarmStatus = TValueOfStringRecord<typeof EAlarmStatus>
export type TAlarmStatusTitle = TValueOfStringRecord<typeof EAlarmStatusTitle>

export const EAlarmManagementView = {
	perVendor: 'per-vendor',
	combined: 'combined',
} as const;

export const EBenetelAlarmStatus = {
	enabled: 'ENABLED',
	disabled: 'DISABLED',
} as const;

export type TBenetelAlarmStatus = TValueOfStringRecord<typeof EBenetelAlarmStatus>

export type TAlarmManagementView = TValueOfStringRecord<typeof EAlarmManagementView>

export type FrequencyValuesType = `${TFrequency}`;
export type RenotifyValuesType = `${TRenotify}`;
